<template>
  <div class="conversations-modal">
    <div class="conversations-modal__backdrop" @click="closeModal()"></div>
    <div class="conversations-modal__dialog">
      <header class="conversations-modal__header">
        <div class="conversations-modal__title" v-if="contactProfile">
          <n-avatar :name="contactName" :imageUrl="contactProfile.avatarUrl" :enableTooltip="true"></n-avatar>
          <h2>{{ contactName }}</h2>
        </div>
        <button @click="closeModal()" class="delete conversations-modal__close-button" aria-label="close"></button>
      </header>
      <div class="conversations-modal__main">
        <ContactConversationList
          :conversations="conversations"
          :loading="loadingContactProfile"
          :workspaceId="currentWorkspace.id"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ContactProfile } from '../models/contactProfile';
import { Conversation } from '../models/conversation';
import { conversationApi } from '../services/conversationApi';
import ContactConversationList from './ContactConversationList.vue';
import { useStore } from 'vuex';
import { computed, onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';

const route = useRoute();
const router = useRouter();
const store = useStore();
const currentWorkspace = computed(() => store.getters.currentWorkspace);

const contactId = ref('');
const loadingContactProfile = ref(false);
const conversations = ref<Conversation[]>([]);
const contactProfile = ref<ContactProfile>();
const contactName = computed(() => contactProfile.value?.name || 'Unknown');

onMounted(async () => {
  contactId.value = <string>route.params.id;
  await loadContactProfile();
});

async function loadContactProfile(): Promise<void> {
  loadingContactProfile.value = true;
  const response = await conversationApi.getContactProfile(currentWorkspace.value.id, contactId.value);
  conversations.value = response.conversations;
  contactProfile.value = response.contact;
  loadingContactProfile.value = false;
}

function closeModal() {
  router.push({ name: 'contacts-list' });
}
</script>

<style lang="scss" scoped>
.conversations-modal {
  align-items: center;
  bottom: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 40;
  &__backdrop {
    background-color: rgba(10, 10, 10, 0.6);
    bottom: 0;
    left: 0;
    position: absolute;
    right: 0;
    top: 0;
  }
  &__close-button {
    cursor: pointer;
    display: inline-block;
    margin-left: auto;
  }
  &__dialog {
    display: flex;
    flex-direction: column;
    max-height: calc(100vh - 40px);
    background: #f2f2f2;
    z-index: 50;
    border-radius: 6px;
    overflow: hidden;
    @media screen and (min-width: 769px) {
      margin: 0 auto;
      width: 640px;
    }
  }
  &__header,
  &__footer {
    align-items: center;
    background-color: #fff;
    display: flex;
    flex-shrink: 0;
    justify-content: flex-start;
    padding: 1rem;
    position: relative;
  }
  &__header {
    position: sticky;
    width: 100%;
    top: 0;
    left: 0;
    z-index: 50;
    border: 1px solid #d3d3d3;
  }
  &__main {
    height: 75vh;
    overflow: auto;
  }
  &__title {
    font-size: 1.5625rem;
    display: flex;
    align-items: center;
    .n-avatar {
      margin-right: 1rem;
    }
  }
}
</style>
